import angular from 'angular';
import { EVENT_HANDLERS_MAP } from './integration-types';
//integrate extension subscriptions with angular $on
export function applySubscriptionIntegrations() {
    angular.element(document).ready(function () {
        for (const event in EVENT_HANDLERS_MAP) {
            const handler = EVENT_HANDLERS_MAP[event];
            angular
                .element(document)
                .injector()
                .get('$rootScope')
                .$on(event, handler);
        }
    });
}
